/* eslint-disable react/require-default-props */
import React, {
    useRef,
    useEffect,
    useState,
} from 'react';
import PropTypes from 'prop-types';
import ScrollLock from 'react-scrolllock';

import { Mobile, Desktop } from 'app/components/Responsive';
import { UIButton } from 'app/components/ui';

import logoSrc from '../../../assets/images/logo-d.svg';

import './age-gate.scss';


export default function AgeGate(props) {
    const {
        onClickResolve,
        onClickReject,
        imageUrl = '',
    } = props;

    const scrollableContentRef = useRef();

    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        // className используется для возможности задания кастомных стилей, т.к. нет хэша
        <div styleName="age-gate__root" className="age-gate__root">
            <Desktop>
                <div styleName="age-gate__logo-wrapper">
                    <picture>
                        <source media="(min-width: 1024px)" srcSet={logoSrc} />
                        <img alt="EE" styleName="age-gate__logo" />
                    </picture>
                </div>
            </Desktop>

            <div styleName="age-gate__wrapper" ref={scrollableContentRef}>
                {imageUrl && (
                    <Desktop>
                        <div styleName="age-gate__image-wrapper">
                            <img
                                styleName="age-gate__image"
                                src={imageUrl}
                                alt="age-gate"
                            />
                        </div>
                    </Desktop>
                )}

                <div styleName="age-gate__content-container">
                    <div styleName="age-gate__titles-container">
                        <p styleName="age-gate__age-title">
                            <span styleName="num">18</span>
                            <span styleName="plus">+</span>
                        </p>
                        <p styleName="age-gate__title">
                            Для доступа необходимо подтвердить совершеннолетний возраст
                        </p>
                    </div>

                    <Mobile isWideMobile>
                        <div styleName="age-gate__separator" />
                    </Mobile>

                    <div styleName="age-gate__bottom-container">
                        <div styleName="ageGateWhiteSpace" />
                        {/* <p styleName="age-gate__warning-text">
                            Сайт содержит информацию для лиц совершеннолетнего возраста.
                            Сведения, размещенные на&nbsp;сайте, не&nbsp;являются рекламой,
                            носят исключительно информационный характер, и&nbsp;предназначены
                            только для личного использования.
                        </p>
                        <br />
                        <p styleName="age-gate__warning-text">
                            Пожалуйста, подтвердите ваш возраст.
                        </p> */}
                        <div styleName="age-gate__button-container">
                            <UIButton
                                onClick={onClickResolve}
                                aria-label="ДА, мне есть 18 лет"
                            >
                                <span>
                                    Да, мне исполнилось&nbsp;
                                    <span className="num">18</span>
                                </span>
                            </UIButton>
                        </div>
                        <div styleName="age-gate__buttons-container">
                            <div styleName="age-gate__button-container">
                                <UIButton
                                    colorType="secondary"
                                    onClick={onClickReject}
                                    aria-label="НЕТ, мне меньше 18 лет"
                                >
                                    <span>
                                        Нет, мне меньше&nbsp;
                                        <span className="num">18</span>
                                    </span>
                                </UIButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isMounted && (
                <ScrollLock touchScrollTarget={scrollableContentRef.current} />
            )}
        </div>
    );
}

AgeGate.propTypes = {
    onClickResolve: PropTypes.func.isRequired,
    onClickReject: PropTypes.func.isRequired,
    imageUrl: PropTypes.string,
};
